module.exports = __webpack_public_path__ + "img/Banner chico 3.e87860fe.png";